<template>
  <div class="index">
    <div class="banner">
      <div class="banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="module ani" swiper-animate-effect="bounceInRight">
              <div class="h1">ZTMap3D</div>
              <div class="line"></div>
              <div class="h2">三维融合渲染平台</div>
              <div class="p">
                实现多架构的三维模型实时渲染基于最新的前端绘图技术开发解决三维渲染跨平台兼容性
              </div>
              <div class="btn" v-jump="'/product/product3'">查看详情</div>
            </div>
            <div class="img img3 ani" swiper-animate-effect="bounceInUp">
              <img
                class="img3"
                src="../assets/images/index/banner_img3.png"
                alt=""
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="module ani" swiper-animate-effect="bounceInRight">
              <div class="h1">ZTMapVR</div>
              <div class="line"></div>
              <div class="h2">VR全景三维可视化平台</div>
              <div class="p">
                行业领先的创新实景VR引擎实现三维模型构建、沉浸式渲染
              </div>
              <div class="btn" v-jump="'/product/product4'">查看详情</div>
            </div>
            <div class="img img4 ani" swiper-animate-effect="bounceInUp">
              <img
                class="img4"
                src="../assets/images/index/banner_img4.png"
                alt=""
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="module ani" swiper-animate-effect="bounceInRight">
              <div class="h1">ZTMapGIS</div>
              <div class="line"></div>
              <div class="h2">二三维GIS地理信息平台</div>
              <div class="p">
                轻松实现传统二维地图应用在线离线一体化解决方案成熟SDK支持快速定制开发
              </div>
              <div class="btn" v-jump="'/product/product1'">查看详情</div>
            </div>
            <div class="img img1 ani" swiper-animate-effect="bounceInUp">
              <img
                class="img1"
                src="../assets/images/index/banner_img1.png"
                alt=""
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="module ani" swiper-animate-effect="bounceInRight">
              <div class="h1">ZTMapEasy</div>
              <div class="line"></div>
              <div class="h2">2.5D-GIS平台</div>
              <div class="p">
                提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力
              </div>
              <div class="btn" v-jump="'/product/product2'">查看详情</div>
            </div>
            <div class="img img2 ani" swiper-animate-effect="bounceInUp">
              <img
                class="img2"
                src="../assets/images/index/banner_img2.png"
                alt=""
              />
            </div>
          </div>

          <div class="swiper-slide">
            <div class="module ani" swiper-animate-effect="bounceInRight">
              <div class="h1">ZTMapIndoor</div>
              <div class="line"></div>
              <div class="h2">室内地图可视化平台</div>
              <div class="p">
                专业的室内地图和定位引擎提供室内地图定位导航综合解决方案
              </div>
              <div class="btn" v-jump="'/product/product5'">查看详情</div>
            </div>
            <div class="img img5 ani" swiper-animate-effect="bounceInUp">
              <img
                class="img5"
                src="../assets/images/index/banner_img5.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="progress">
        <div class="module">
          <div
            :class="{ active: bannerData.index == 0 }"
            @click="bannerItemClick(0)"
          >
            <img
              v-if="bannerData.index != 0"
              src="../assets/images/index/map3d.png"
              style="width:51px;height:53px;"
            />
            <img
              v-if="bannerData.index == 0"
              src="../assets/images/index/map3d_active.png"
              style="width:51px;height:53px;"
            />
            <span>ZTMap3D</span>
          </div>
          <div
            :class="{ active: bannerData.index == 1 }"
            @click="bannerItemClick(1)"
          >
            <img
              v-if="bannerData.index != 1"
              src="../assets/images/index/mapvr.png"
              style="width:58px;height:45px;"
            />
            <img
              v-if="bannerData.index == 1"
              src="../assets/images/index/mapvr_active.png"
              style="width:58x;height:45px;"
            />
            <span>ZTMapVR</span>
          </div>
          <div
            :class="{ active: bannerData.index == 2 }"
            @click="bannerItemClick(2)"
          >
            <img
              v-if="bannerData.index != 2"
              src="../assets/images/index/mapgis.png"
              style="width:52px;height:52px;"
            />
            <img
              v-if="bannerData.index == 2"
              src="../assets/images/index/mapgis_active.png"
              style="width:52px;height:52px;"
            />
            <span>ZTMapGIS</span>
          </div>
          <div
            :class="{ active: bannerData.index == 3 }"
            @click="bannerItemClick(3)"
          >
            <img
              v-if="bannerData.index != 3"
              src="../assets/images/index/mapeasy.png"
              style="width:49px;height:55px;"
            />
            <img
              v-if="bannerData.index == 3"
              src="../assets/images/index/mapeasy_active.png"
              style="width:49px;height:55px;"
            />
            <span>ZTMapEasy</span>
          </div>

          <div
            :class="{ active: bannerData.index == 4 }"
            @click="bannerItemClick(4)"
          >
            <img
              v-if="bannerData.index != 4"
              src="../assets/images/index/mapindoor.png"
              style="width:50px;height:49px;"
            />
            <img
              v-if="bannerData.index == 4"
              src="../assets/images/index/mapindoor_active.png"
              style="width:50px;height:49px;"
            />
            <span>ZTMapIndoor</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-banner">
      <div class="banner-swiper2">
        <div class="swiper-wrapper2">
          <el-carousel trigger="click" height="24rem">
            <el-carousel-item>
              <div class="swiper-slide2">
                <div class="module ani">
                  <div class="h1">ZTMap3D</div>
                  <div class="line"></div>
                  <div class="h2">三维融合渲染平台</div>
                  <div class="p">
                    实现多架构的三维模型实时渲染基于最新的前端绘图技术开发解决三维渲染跨平台兼容性
                  </div>
                  <div class="btns" v-jump="'/product/product3'">查看详情</div>
                </div>
                <div class="img img3 ani">
                  <img
                    class="img3"
                    src="../assets/images/index/banner_img3.png"
                    alt=""
                  />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="swiper-slide2">
                <div class="module ani" swiper-animate-effect="bounceInRight">
                <div class="h1">ZTMapVR</div>
                <div class="line"></div>
                <div class="h2">VR全景三维可视化平台</div>
                <div class="p">
                  行业领先的创新实景VR引擎实现三维模型构建、沉浸式渲染
                </div>
                <div class="btns" v-jump="'/product/product4'">查看详情</div>
              </div>
              <div class="img img4 ani" swiper-animate-effect="bounceInUp">
                <img
                  class="img4"
                  src="../assets/images/index/banner_img4.png"
                  alt=""
                />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="swiper-slide2">
                <div class="module ani" swiper-animate-effect="bounceInRight">
                <div class="h1">ZTMapGIS</div>
                <div class="line"></div>
                <div class="h2">二三维GIS地理信息平台</div>
                <div class="p">
                  轻松实现传统二维地图应用在线离线一体化解决方案成熟SDK支持快速定制开发
                </div>
                <div class="btns" v-jump="'/product/product1'">查看详情</div>
              </div>
              <div class="img img1 ani" swiper-animate-effect="bounceInUp">
                <img
                  class="img1"
                  src="../assets/images/index/banner_img1.png"
                  alt=""
                />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="swiper-slide2">
                <div class="module ani" swiper-animate-effect="bounceInRight">
                <div class="h1">ZTMapEasy</div>
                <div class="line"></div>
                <div class="h2">2.5D-GIS平台</div>
                <div class="p">
                  提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力
                </div>
                <div class="btns" v-jump="'/product/product2'">查看详情</div>
              </div>
              <div class="img img2 ani" swiper-animate-effect="bounceInUp">
                <img
                  class="img2"
                  src="../assets/images/index/banner_img2.png"
                  alt=""
                />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="swiper-slide2">
                <div class="module ani" swiper-animate-effect="bounceInRight">
                <div class="h1">ZTMapIndoor</div>
                <div class="line"></div>
                <div class="h2">室内地图可视化平台</div>
                <div class="p">
                  专业的室内地图和定位引擎提供室内地图定位导航综合解决方案
                </div>
                <div class="btns" v-jump="'/product/product5'">查看详情</div>
              </div>
              <div class="img img5 ani" swiper-animate-effect="bounceInUp">
                <img
                  class="img5"
                  src="../assets/images/index/banner_img5.png"
                  alt=""
                />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="develop">
      <titleTemp1 :data="develop"></titleTemp1>
      <div class="module">
        <div>
          <div v-jump="'/product/product3'">
            <img src="../assets/images/development/dev1.jpg" alt="" />
            <div class="title">三维融合渲染平台</div>
            <div class="content">
              二三维GIS数据渲染支持、BIM数据渲染支持、GIS+BIM场景融合渲染、海量三维数据极速渲染、地理坐标&amp;BIM坐标转换、GIS+BIM空间分析、三维特效模块组、可视化交互式开发工具。提供基于JavaScript+H5跨平台的简洁开发API...
            </div>
          </div>
          <div v-jump="'/product/product1'">
            <img src="../assets/images/development/dev2.jpg" alt="" />
            <div class="title">二三维GIS地理信息平台</div>
            <div class="content">
              实现二维GIS地图和三维GIS地图的可视化渲染；二三维GIS地图点线面标绘；地图事件响应机制和接口；图层叠加控制、地图热力图、专题图等；电子围栏功能；路线导航功能。提供基于JavaScript+H5跨平台的二三维GIS简洁开发API...
            </div>
          </div>
        </div>
        <div>
          <div v-jump="'/product/product2'">
            <img src="../assets/images/development/dev3.jpg" alt="" />
            <div class="title">2.5D-GIS平台</div>
            <div class="content">
              实现2.5D地图GIS渲染发布，基于2.5D地图的浏览、漫游、缩放、刷新等基本功能；实现基于2.5D地图的点线面标绘、热力图、专题图等功能，2.5D地图与VR全景的结合等。提供基于JavaScript+H5跨平台的简洁开发...
            </div>
          </div>
          <div v-jump="'/product/product4'">
            <img src="../assets/images/development/dev4.jpg" alt="" />
            <div class="title">VR全景三维可视化平台</div>
            <div class="content">
              实现三维全景VR沉浸式漫游功能，基于三维全景图片的深度映射建模工具，创新性的三维建模+全景VR技术融合。提供免费的VR全景和三维建模PASS平台...
            </div>
          </div>
          <div v-jump="'/product/product5'">
            <img src="../assets/images/development/dev5.jpg" alt="" />
            <div class="title">室内地图可视化平台</div>
            <div class="content">
              室内地图在线可视化编辑绘制、室内地图三维GIS渲染、室内地图图层管理、室内地图查询检索、室内地图图形标绘、室内地图操作事件自定义、室内地图路线导航。提供基于JavaScript+H5跨平台的简洁开发API...
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='mobile-develop'>
      <div class="titles">
        <div class="title">开发中心</div>
        <div class="en-title">develop</div>
      </div>
      <div class="images">
        <div class="image1"  v-jump="'/product/product3'">
          <!-- <img src="../assets/images/index/image1.png" alt=""> -->
          <div v-jump="'/product/product3'">三维融合渲染平台</div>
        </div>
        <div class="image3"  v-jump="'/product/product1'">
          <!-- <img src="../assets/images/index/image2.png" alt=""> -->
          <div v-jump="'/product/product3'">二三维GIS地理信息平台</div>
        </div>
        <div class="image2"  v-jump="'/product/product2'">
          <img src="../assets/images/index/image3.png" alt="">
          <div>2.5D-GIS平台</div>
        </div>
        <div class="image2"  v-jump="'/product/product4'">
          <img src="../assets/images/index/image4.png" alt="">
          <div>VR全景三维可视化平台</div>
        </div>
        <div class="image2"  v-jump="'/product/product5'">
          <img src="../assets/images/index/image5.png" alt="">
          <div>室内地图可视化平台</div>
        </div>
      </div>
    </div>
    <div class="application">
      <titleTemp1 :data="application"></titleTemp1>
      <div class="module">
        <div>
          <div>
            <div class="title">
              <img src="../assets/images/index/zhyq.png" />
              <span>智慧园区可视化管理</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/zhsc.png" />
              <span>智慧园区可视化管理</span>
              <p>
                建立基于BIM、GIS、VR可视化技术和物联网技术的精细化运营管理平台。以运营数据管理平台为数据支撑，通过三维场景展示3DGIS和建筑BIM模型，同时将3DGIS、BIM模型管理、流程管理……
              </p>
              <div class="btn" v-jump="'/application/application1'">
                查看详情
              </div>
            </div>
          </div>
          <div>
            <div class="title">
              <img src="../assets/images/index/zhsq.png" />
              <span>智慧社区可视化管理</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/zhsq.png" />
              <span>智慧社区可视化管理</span>
              <p>
                依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子……
              </p>
              <div class="btn" v-jump="'/application/application2'">
                查看详情
              </div>
            </div>
          </div>
          <div>
            <div class="title">
              <img src="../assets/images/index/zhjq.png" />
              <span>智慧旅游可视化管理</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/zhjq.png" />
              <span>智慧旅游可视化管理</span>
              <p>
                景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设，提高旅游生态环……
              </p>
              <div class="btn" v-jump="'/application/application3'">
                查看详情
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div class="title">
              <img src="../assets/images/index/zhsc.png" />
              <span>商业地产大数据可视化分析</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/zhsc.png" />
              <span>商业地产大数据可视化分析</span>
              <p>
                臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺按照租……
              </p>
              <div class="btn" v-jump="'/application/application4'">
                查看详情
              </div>
            </div>
          </div>
          <div>
            <div class="title">
              <img src="../assets/images/index/zhaf.png" />
              <span>智慧安防可视化管理</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/zhaf.png" />
              <span>智慧安防可视化管理</span>
              <p>
                基于BIM、GIS可视化技术和物联网技术，整合视频监控信息，运用视频识别和AI分析技术，实现智能安防管理平台。
                将安防相关的门禁、告警、设备设施、车辆、人员、资产、房屋等……
              </p>
              <div class="btn" v-jump="'/application/application5'">
                查看详情
              </div>
            </div>
          </div>
          <div>
            <div class="title">
              <img src="../assets/images/index/yjzh.png" />
              <span>应急指挥可视化管理</span>
            </div>
            <div class="content">
              <img src="../assets/images/index/yjzh.png" />
              <span>应急指挥可视化管理</span>
              <p>
                可视化应急指挥系统是基于先进二维、三维GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……
              </p>
              <div class="btn" v-jump="'/application/application6'">
                查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more" v-jump="'/application'">查看更多</div>
    </div>
    <div class="mobile-application">
      <div class="titles">
        <div class="title">行业应用</div>
        <div class="en-title">APPLICATION</div>
      </div>
      <div class="images">
        <div class="image3-1"  v-jump="'/application/application1'">
          <img src="../assets/images/index/app1.jpg" alt="">
          <div>智慧园区 可视化管理</div>
        </div>
        <div class="image3-2"  v-jump="'/application/application2'">
          <img src="../assets/images/index/app2.jpg" alt="">
          <div>智慧社区 可视化管理</div>
        </div>
        <div class="image3-2"  v-jump="'/application/application3'">
          <img src="../assets/images/index/app3.jpg" alt="">
          <div>智慧旅游 可视化管理</div>
        </div>
        <div class="image3-1"  v-jump="'/application/application4'">
          <img src="../assets/images/index/app4.jpg" alt="">
          <div style="width: 10rem;">商业地产大数据可视化分析</div>
        </div>
        <div class="image3-1"  v-jump="'/application/application5'">
          <img src="../assets/images/index/app6.jpg" alt="">
          <div>应急指挥 可视化管理</div>
        </div>
        <div class="image3-2"  v-jump="'/application/application6'">
          <img src="../assets/images/index/app5.jpg" alt="">
          <div>智慧安防 可视化管理</div>
        </div>
      </div>
      <div class="see-more">
        <a href="/application">
          <span>查看更多</span>
          <span>>></span>
        </a>
      </div>
    </div>
    <div class="CASE">
      <titleTemp1 :data="CASE"></titleTemp1>
      <div class="module">
        <div class="CASE-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="img img1"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img2"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img3"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img4"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img5"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img6"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img7"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img8"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img9"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img10"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img11"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img12"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img13"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img14"></div>
            </div>
            <div class="swiper-slide">
              <div class="img img15"></div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="more" v-jump="'/case'">查看更多</div>
    </div>
    <div class="mobile-case">
      <div class="titles">
        <div class="title">经典案例</div>
        <div class="en-title">CASE</div>
      </div>
      <div class="case-swiper">
        <el-carousel class="case-carousel" height="78vw" >
          <el-carousel-item v-for=" index in 15" :key="index">
            <img :src="getImg(`case_${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
          </el-carousel-item>
        </el-carousel>
        <div class="see-more">
          <a href="/case">
            <span>查看更多</span>
            <span>>></span>
          </a>
        </div>
      </div>
    </div>
    <div class="advantage">
      <titleTemp1 :data="advantage"></titleTemp1>
      <div class="module">
        <div class="content">
          <div class="list">
            <div>
              <div class="title">定位优势</div>
              <div class="p">
                公司战略定位清晰，以用户为中心，建立项目专理服务体系，紧密结合用户场景，提供专业高效优质服务。
              </div>
            </div>
            <div>
              <div class="title">团队优势</div>
              <div class="p">
                全方位自有团队，能力全面，成熟稳定，一站式、扁平化服务无短板。
              </div>
            </div>
            <div>
              <div class="title">产品优势</div>
              <div class="p">
                拥有二三维地图、三维GIS渲染引擎、室内地图定位平台全系列自主产权产品，兼具定制灵活性和产品的成熟性。
              </div>
            </div>
            <div>
              <div class="title">经验优势</div>
              <div class="p">
                超过15年、横跨行业、高度专业于空间信息可视化系统的服务经验。
              </div>
            </div>
          </div>
          <div class="mores" v-jump="'/service'">查看更多 ></div>
        </div>
      </div>
    </div>
    <div class="mobile-advantage">
      <div class="titles">
        <div class="title">服务优势</div>
        <div class="en-title">ADVANTAGE</div>
      </div>
      <div class="advantage-content">
        <div class="content-list">
          <div class="title">
            <img src="../assets/images/index/dwys.png" alt="">
            <p>定位优势</p>
          </div>
          <div class="p">
            公司战略定位清晰，以用户为中心，建立项目专理服务体系，紧密结合用户场景，提供专业高效优质服务。
          </div>
        </div>
        <div class="content-list">
          <div class="title">
            <img src="../assets/images/index/tdys.png" alt="">
            <p>团队优势</p>
          </div>
          <div class="p">
            全方位自有团队，能力全面，成熟稳定，一站式、扁平化服务无短板
          </div>
        </div>
        <div class="content-list">
          <div class="title">
            <img src="../assets/images/index/cpys.png" alt="">
            <p>产品优势</p>
          </div>
          <div class="p">
            拥有二三维地图、三维GIS渲染引擎、室内地图定位平台全系列自主产权产品，兼具定制灵活性和产品的成熟性。
          </div>
        </div>
        <div class="content-list">
          <div class="title">
            <img src="../assets/images/index/jyys.png" alt="">
            <p>经验优势</p>
          </div>
          <div class="p">
            超过15年、横跨行业、高度专业于空间信息可视化系统的服务经验。
          </div>
        </div>
        <div class="mores" v-jump="'/service'">查看更多  >></div>
      </div>
    </div>
    <div class="partner">
      <titleTemp1 :data="partner"></titleTemp1>
      <div class="module">
        <div class="list">
          <img src="../assets/images/index/partners.png" alt="" />
          <!-- <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="module ani" swiper-animate-effect="bounceInRight">
                <div class="h1">ZTMap3D</div>
                <div class="line"></div>
                <div class="h2">三维融合渲染平台</div>
                <div class="p">
                  实现多架构的三维模型实时渲染基于最新的前端绘图技术开发解决三维渲染跨平台兼容性
                </div>
                <div class="btn" v-jump="'/product/product3'">查看详情</div>
              </div>
              <div class="img img3 ani" swiper-animate-effect="bounceInUp">
                <img
                  class="img3"
                  src="../assets/images/index/banner_img3.png"
                  alt=""
                />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="mobile-partner">
      <div class="titles">
        <div class="title">合作伙伴</div>
        <div class="en-title">PARTNER</div>
      </div>
      <div class="partner-img">
        <img src="../assets/images/index/partner.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  metaInfo: {
    title:
      '三维GIS地图引擎_3DGIS+BIM融合渲染平台_数字孪生_ZTMap_专业智慧城市三维可视化服务商-上海臻图信息技术有限公司',
    meta: [
      {
        name: 'keywords',
        content:
          '数字孪生，三维可视化,三维渲染,2.5D地图,三维地图,三维GIS,3D-GIS,2.5D-GIS,VR三维全景,室内地图GIS平台,室内定位,智慧园区,智慧社区,智慧安防,应急指挥,三维管网管线,商业地产可视化,智慧环保,智慧交通,智慧展馆,智慧管廊,智慧消防'
      },
      {
        name: 'description',
        content:
          '上海臻图信息技术有限公司是行业领先的空间信息三维可视化产品开发和服务提供商，致力于以空间信息可视化和时空大数据AI分析的创新视角为智慧城市信息化建设赋能。三维GIS+BIM平台、实景三维、VR全景、室内定位产品。'
      }
    ]
  },
  data () {
    return {
      bannerData: {
        index: 0,
        bannerSwiper: null
      },
      develop: {
        title: '开发中心',
        subtitle: 'DEVELOP'
      },
      application: {
        title: '行业应用',
        subtitle: 'APPLICATION',
        bgType: true
      },
      CASE: {
        title: '经典案例',
        subtitle: 'CASE'
      },
      advantage: {
        title: '服务优势',
        subtitle: 'ADVANTAGE'
      },
      partner: {
        title: '合作伙伴',
        subtitle: 'PARTNER'
      }
    }
  },
  methods: {
    bannerItemClick: function (index) {
      console.log(index)
      this.bannerData.bannerSwiper.slideTo(index, 233, true) // 切换到第一个slide，速度为1秒
    },
    getImg(fileName) {
      return require(`@/assets/images/case/${fileName}`);
    }
  },
  mounted: function () {
    let that = this
    /* 轮播控制点 */
    for (let i = 1; i <= 5; i++) {
      this.$scrollReveal.reveal('.progress div:nth-child(' + i + ')', {
        duration: 500,
        delay: 100 * i,
        origin: 'bottom',
        reset: false,
        mobile: false,
        distance: '88px',
        opacity: 0.001,
        easing: 'linear'
      })
    }
    /* 所有的标题和内容 */
    this.$scrollReveal.reveal('.index .module', {
      duration: 500,
      delay: 100,
      origin: 'bottom',
      reset: false,
      mobile: false,
      distance: '88px',
      opacity: 0.001,
      easing: 'linear'
    })
    this.bannerData.bannerSwiper = new this.$Swiper('.banner-swiper', {
      speed: 230,
      autoplay: {
        disableOnInteraction: false, // 手动滑动之后不打断播放
        delay: 10000
      },
      // loop: true,
      // observer: true,
      // observeParents: true,
      on: {
        // init: function() {
        init: function () {
          swiperAnimateCache(this) // 隐藏动画元素
          swiperAnimate(this) // 初始化完成开始动画
        },
        slideChangeTransitionStart: function () {
          that.bannerData.index = this.activeIndex
        },
        slideChangeTransitionEnd: function () {
          swiperAnimate(this) // 每个slide切换结束时也运行当前slide动画
          // this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
        }
      }
    })
    var caseSwiper = new this.$Swiper('.CASE-swiper', {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      autoplay: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        progress: function (progress) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i)
            var slideProgress = this.slides[i].progress
            var modify = 1
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
            }
            var translate = slideProgress * modify * 432 + 'px'
            var scale = 1 - Math.abs(slideProgress) / 5
            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
            slide.transform(
              'translateX(' + translate + ') scale(' + scale + ')'
            )
            slide.css('zIndex', zIndex)
            slide.css('opacity', 1)
            if (Math.abs(slideProgress) > 3) {
              slide.css('opacity', 0)
            }
          }
        },
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i)
            slide.transition(transition)
          }
        }
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.index {
  .banner {
    margin-top: 70px;
    .banner-swiper {
      height: 813px;
      background: #fff url("../assets/images/index/banner_bg.jpg") no-repeat
        center center / 100% 100%;
      position: relative;
      overflow: hidden;
      .module {
        color: #fff;
        .h1 {
          font-size: 50px;
          line-height: 50px;
          margin: 102px 0 20px 0;
        }
        .line {
          width: 80px;
          height: 4px;
          background: #fff;
        }
        .h2 {
          font-size: 30px;
          line-height: 30px;
          margin: 70px 0 20px 0;
        }
        .p {
          font-size: 20px;
          line-height: 28px;
          width: 500px;
        }
        .btn {
          padding: 11px 50px;
          background: linear-gradient(
            270deg,
            rgba(105, 192, 255, 1) 0%,
            rgba(111, 250, 255, 1) 100%
          );
          border-radius: 25px;
          display: inline-block;
          margin-top: 66px;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .img {
        background: no-repeat center center / 100%;
        position: absolute;
        top: 0;
        right: 0;
      }
      .img1 {
        background: url("../assets/images/index/banner_img1.png") no-repeat
          center center;
        width: 868px;
        height: 773px;
        background-size: 868px 773px;
      }
      .img2 {
        background: url("../assets/images/index/banner_img2.png") no-repeat
          center center;
        width: 832px;
        height: 742px;
        background-size: 870px 742px;
      }
      .img3 {
        background: url("../assets/images/index/banner_img3.png") no-repeat
          center center;
        width: 870px;
        height: 742px;
        background-size: 863px 742px;
      }
      .img4 {
        background: url("../assets/images/index/banner_img4.png") no-repeat
          center center;
        width: 765px;
        height: 694px;
        background-size: 765px 694px;
      }
      .img5 {
        background: url("../assets/images/index/banner_img5.png") no-repeat
          center center;
        width: 863px;
        height: 743px;
        background-size: 832px 743px;
      }
    }
    .progress {
      margin-bottom: 80px;
      .module {
        display: flex;
        margin-top: -168px;
        position: absolute;
        left: 50%;
        margin-left: -600px;
        z-index: 999;
        > div {
          cursor: pointer;
          flex: 1;
          height: 255px;
          background: @baseColor;
          background: url("../assets/images/index/banner_item.png") no-repeat
            center center / 200px 200px;
          text-align: center;
          display: flex;
          flex-direction: column;
          &.active {
            background-image: url("../assets/images/index/banner_item_hover.png");
            background-size: 255px 255px;
            span {
              color: @baseColor;
            }
          }
          img {
            display: block;
            margin: 80px auto 8px;
          }
          span {
            font-size: 20px;
            color: rgba(75, 75, 75, 1);
            line-height: 28px;
          }
        }
      }
    }
  }
  .develop {
    padding: 78px 0 100px 0;
    > .module > div {
      display: flex;
      &:first-child {
        margin-bottom: 20px;
        img {
          width: 100%;
        }
        & > div {
          .content {
            padding: 0 100px;
          }
        }
        & > div:nth-child(1) {
          background-image: url("../assets/images/development/dev1.jpg");
        }
        & > div:nth-child(2) {
          background-image: url("../assets/images/development/dev2.jpg");
        }
      }
      &:last-child {
        & > div {
          .content {
            padding: 0 69px;
          }
        }
        & > div:nth-child(1) {
          background-image: url("../assets/images/development/dev3.jpg");
        }
        & > div:nth-child(2) {
          background-image: url("../assets/images/development/dev4.jpg");
        }
        & > div:nth-child(3) {
          background-image: url("../assets/images/development/dev5.jpg");
        }
      }
      > div {
        height: 401px;
        margin-right: 20px;
        flex: 1;
        background: no-repeat center center / cover;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        &:hover {
          .content {
            opacity: 1;
            bottom: 0;
          }
        }
        .title {
          font-size: 26px;
          text-align: center;
          color: #fff;
          position: absolute;
          top: 0;
          width: 100%;
          top: 68px;
        }
        .content {
          height: 150px;
          background: rgba(0, 0, 0, 0.2);
          position: absolute;
          bottom: -100%;
          align-items: center;
          display: flex;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          text-align: center;
          line-height: 20px;
          opacity: 0;
          transition: 0.2s opacity linear, 0.2s bottom linear;
        }
      }
    }
  }
  .application {
    background: #f8f8f8;
    padding: 40px 0;
    .module > div {
      display: flex;
      img {
        display: block;
      }
      &:first-child {
        margin-bottom: 20px;
        & > div:nth-child(1) {
          min-width: 548px;
          flex: 1;
          background-image: url("../assets/images/index/app1.jpg");
          img {
            width: 32px;
          }
        }
        & > div:nth-child(2) {
          background-image: url("../assets/images/index/app2.jpg");
          img {
            width: 34px;
          }
        }
        & > div:nth-child(3) {
          background-image: url("../assets/images/index/app3.jpg");
          img {
            width: 39px;
          }
        }
      }
      &:last-child {
        & > div:nth-child(1) {
          background-image: url("../assets/images/index/app4.jpg");
          img {
            width: 32px;
          }
        }
        & > div:nth-child(2) {
          background-image: url("../assets/images/index/app5.jpg");
          img {
            width: 36px;
          }
        }
        & > div:nth-child(3) {
          min-width: 548px;
          flex: 1;
          background-image: url("../assets/images/index/app6.jpg");
          img {
            width: 30px;
          }
        }
      }
      > div {
        height: 301px;
        margin-right: 20px;
        flex: 1;
        background: no-repeat center center / cover;
        position: relative;
        perspective: 1000;
        > div {
          transition: all 0.2s linear;
          position: absolute;
          height: 100%;
          width: 100%;
          backface-visibility: hidden;
          text-align: center;
        }
        &:hover {
          .title {
            transform: rotateY(-180deg);
          }
          .content {
            transform: rotateY(-360deg);
          }
        }
        .title {
          font-size: 20px;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          > img {
            margin: 116px auto 10px auto;
          }
        }
        .content {
          background: rgba(2, 118, 247, 0.9);
          transform: rotateY(-180deg);
          padding: 0 25px;
          color: #fff;
          box-sizing: border-box;
          font-size: 14px;
          > span {
            font-size: 20px;
          }
          > img {
            margin: 58px auto 10px auto;
          }
          > p {
            margin: 10px 0 20px 0;
            color: rgba(255, 255, 255, 0.6);
            line-height: 20px;
          }
          .btn {
            padding-bottom: 5px;
            border-bottom: 1px solid #fff;
            display: inline-block;
            margin: 0 auto;
            cursor: pointer;
          }
        }
      }
    }
    .more {
      margin-top: 50px;
    }
  }
  .CASE {
    margin: 0 auto;
    padding: 100px 0;
    .module {
      width: 900px;
      position: relative;
    }
    .CASE-swiper {
      overflow: hidden;
    }
    .swiper-slide {
      width: 580px;
      height: 400px;
      background: #ccc;
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.4);
      .img {
        height: 100%;
      }
      @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15;
      .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
        .img@{val} {
          background: url("../assets/images/case/case_@{val}.jpg") no-repeat top
            center / 100% auto;
        }
        .ml-loop(@list, (@i+1));
      }
      .ml-loop(@List);
    }
    .swiper-button-prev {
      left: -74px;
      width: 45px;
      height: 45px;
      background: url(../assets/images/index/left.png) no-repeat;
      background-position: 0 0;
      background-size: 100%;
    }
    .swiper-button-next {
      right: -74px;
      width: 45px;
      height: 45px;
      background: url(../assets/images/index/right.png) no-repeat;
      background-position: 0 0;
      background-size: 100%;
    }
    .swiper-button-prev,
    .swiper-button-next {
      &:after {
        content: none;
      }
    }
    .more {
      margin-top: 50px;
    }
  }
  .advantage {
    .module {
      height: 461px;
      padding: 67px 0 66px 0;
      box-sizing: border-box;
      background: url("../assets/images/index/advantage_bg.jpg") no-repeat
        center center / cover;
      width: 100%;
    }
    .mores {
      font-size: 18px;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      display: inline-block;
      margin-top: 20px;
      float: right;
    }
    .content {
      height: 100%;
      width: @contentWidth;
      margin: 0 auto;
      .list {
        display: flex;
        height: 100%;
        > div {
          flex: 1;
          background-color: rgba(0, 0, 0, 0.2);
          background-repeat: no-repeat;
          background-position: top 46px center;
          height: 100%;
          margin-right: 20px;
          color: #fff;
          padding: 0 26px;
          .title {
            text-align: center;
            margin: 102px 0 51px 0;
            font-size: 26px;
          }
          .p {
            font-size: 16px;
            line-height: 22px;
          }
          &:nth-child(1) {
            background-image: url("../assets/images/index/dwys.png");
            background-size: 47px 47px;
          }
          &:nth-child(2) {
            background-image: url("../assets/images/index/tdys.png");
            background-size: 42px 43px;
          }
          &:nth-child(3) {
            background-image: url("../assets/images/index/cpys.png");
            background-size: 46px 47px;
          }
          &:nth-child(4) {
            background-image: url("../assets/images/index/jyys.png");
            background-size: 40px 49px;
            margin-right: 0;
          }
        }
      }
    }
  }
  .partner {
    padding: 100px 0;
    .list {
      > img {
        width: 100%;
      }
      > div {
        display: flex;
        align-items: center; // 垂直居中
        margin-bottom: 50px;
        &:nth-child(1) {
          img {
            margin-right: 114px;
          }
        }
        &:nth-child(2) {
          img {
            margin-right: 108px;
          }
        }
        &:nth-child(3) {
          img {
            margin-right: 71px;
          }
        }
        &:nth-child(4) {
          img {
            margin-right: 115px;
          }
        }
      }
    }
  }
  .mobile-banner {
    display: none;
    margin-top: 4rem;
    .banner-swiper2 {
      width: 100%;
      height: 24rem;
      background: linear-gradient(180deg, #0276F7 0%, #9DCFFF 100%);
      position: relative;
      overflow: hidden;
      .swiper-wrapper2 {
        .swiper-slide2 {
          display: flex;
          box-sizing: border-box;
          padding-left: 2rem;
          .module {
            color: #fff;
            width:50%;
            animation: slideInRight 0.5s ease forwards;
            .h1 {
              font-size: 1.8rem;
              line-height: 1.8rem;
              margin: 4rem 0 0 0;
              
            }
            .line {
              width: 4rem;
              height: 0.2rem;
              background: #fff;
              margin-top: 1rem;
            }
            .h2 {
              font-size: 1.4rem;
              line-height: 1.4rem;
              margin: 2rem 0 2rem 0;
            }
            .p {
              font-size: 1rem;
              line-height: 1.5rem;
              width: 15rem;
            }
            .btns {
              padding: 1rem 5rem;
              background: linear-gradient(
                270deg,
                rgba(105, 192, 255, 1) 0%,
                rgba(111, 250, 255, 1) 100%
              );
              border-radius: 2.5rem;
              display: inline-block;
              margin-top: 1.5rem;
              cursor: pointer;
            }
          }
          .img3 ,
          .img1,
          .img2,
          .img4,
          .img5 {
            margin-top: 1.5rem;
            width: 20rem;
            height: 17rem;
            animation: slideInUp 0.5s ease forwards;
            img{ 
              width: 20rem;
              height: 17rem;
            }
          }
        }
      }
    }
  }
  .mobile-develop {
    width: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Normal";
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .images {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .image1 {
        width: 50%;
        height: 12rem;
        display: flex;
        justify-content: center;
        position: relative;
        background-image: url('../assets/images/index/image1.png');
        background-position: center;
        background-size: cover;
        // img {
        //   width: 100%;
        //   pointer-events: none;
        // }
        >div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          // text-align: center;
          // position: absolute;
          // top: 50%;
          // left: 50%;
          // transform: translate(-50%, -50%);
          font-size: 1.4rem;
          font-weight: bold;
          // line-height: 2rem;
          color: #FFFFFF;
          text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
        }
      }
      .image3 {
        width: 50%;
        display: flex;
        justify-content: center;
        position: relative;
        background-image: url('../assets/images/index/image2.png');
        background-position: center;
        background-size: cover;
        // img {
        //   width: 100%;
        //   pointer-events: none;
        // }
        >div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          // text-align: center;
          // position: absolute;
          // top: 50%;
          // left: 50%;
          // transform: translate(-50%, -50%);
          font-size: 1.4rem;
          font-weight: bold;
          // line-height: 2rem;
          color: #FFFFFF;
          text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
        }
      }
      .image2 {
        width: 33.3333%;
        display: flex;
        justify-content: center;
        position: relative;
        img {
          width: 100%;
          pointer-events: none;
        }
        >div {
          width: 8.5rem;
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          color: #FFFFFF;
          text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  .mobile-application {
    width: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Normal";
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .images {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .image3-1 {
        width: 60%;
        height: 37.33333vw;
        margin-top: -0.3rem;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
        >div {
          width: 7rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: "Normal";
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
          color: #FFFFFF;
          text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
        }
      }
      .image3-2 {
        width: 40%;
        height: 37.33333vw;
        margin-top: -0.3rem;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
        >div {
          width: 7rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: "Normal";
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
          color: #FFFFFF;
          text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
        }
      }
    }
    .see-more {
      width: 100%;
      height: 5rem;
      display: flex;
      justify-content: end;
      align-items: center;
      box-sizing: border-box;
      padding-right: 2rem;
      background: rgba(0, 0, 0, 0.03);
      a{
        color: #3C80E8;
        font-family: "Normal";
        span {
          margin-left: 0.5rem;
        }
      }
    }
  }
  .mobile-case {
    width: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Normal";
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .case-swiper {
      width: 100%;
      .see-more {
        width: 100%;
        height: 5rem;
        display: flex;
        justify-content: end;
        align-items: center;
        box-sizing: border-box;
        padding-right: 2rem;
        a{
          color: #3C80E8;
          font-family: "Normal";
          span {
            margin-left: 0.5rem;
          }
        }
      }
    }
  }
  .mobile-advantage {
    width: 100%;
    background: rgba(0, 0, 0, 0.03);
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Normal";
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .advantage-content {
      // height: 36rem;
      width: 100%;
      background-image: url(../assets/images/index/advantage_bg.jpg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      .content-list {
        width: 16.5rem;
        height: 14rem;
        display: flex;
        flex-direction: column;
        background: rgba(0, 0, 0, 0.2);
        margin-top: 1.5rem;
        box-sizing: border-box;
        padding: 1.5rem;
        font-family: 'Normal';
        .title {
          display: flex;
          height:3rem;
          align-items: center;
          justify-content: center;
          p{
            font-size: 1.4rem;
            font-weight: bold;
            line-height: 2rem;
            color: #fff;
            margin-left: 1rem;
          }
          img{
            width: 3rem;
            height: 3rem;
          }
        }
        .p {
          margin-top: 1.5rem;
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          text-align: justify;
          color: #FFFFFF;
        }
      }
      .mores {
        margin-top: 2rem;
        width: 100%;
        height: 3rem;
        align-self: flex-end;
        font-size: 1.4rem;
        font-weight: 350;
        color: #FFFFFF;
        font-family: "Normal";
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        padding: 0 2rem 0 0 ;
      }
    }
  }
  .mobile-partner {
    width: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Normal";
    .titles {
      width: 100%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: "Normal";
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999999;
      }
    }
    .partner-img {
      margin-top: -3rem;
      width: 100%;
      // height: 20rem;
      img {
        width: 100%;
        // height: 100%;
        object-fit: contain;
      }
    }
  }
}

/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 从下滑入 */
@keyframes slideInUp {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (max-width: 1024px) {
  .index {
    .banner {
      display: none;
    }
    .develop {
      display: none;
    }
    .application {
      display: none;
    }
    .CASE {
      display: none;
    }
    .advantage {
      display: none;
    }
    .partner {
      display: none;
    }
    .mobile-banner {
      display: block;
    }
    .mobile-develop {
      display: flex;
    }
    .mobile-application {
      display: flex;
    }
    .mobile-case {
      display: flex;
    }
    .mobile-advantage {
      display: flex;
    }
    .mobile-partner {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue